import axios from "axios";
import { getApiBase } from "../apiBase";
import { buildPluginsHeader } from "./registry";

const AUTH_TOKEN_KEY = "projectBoardAuthToken";

function authHeaders() {
  const h = { ...buildPluginsHeader() };
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) h.Authorization = `Bearer ${token}`;
  } catch {
    /* ignore */
  }
  return h;
}

export async function fetchAdminProjectPhaseHistory() {
  const { data } = await axios.get(`${getApiBase()}/admin/project-phase-history`, {
    headers: authHeaders(),
  });
  return data;
}
